import { Grid, Box } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useEffect } from 'react';
import { IdAndFinancialInformationLink } from './subcomponents/idAndFinancialInformationLink';
import { IdAndFinancialInformationSteps } from './subcomponents/idAndFinancialInformationSteps';
import { IdAndFinancialInformationSections } from './subcomponents/idAndFinancialSections';
import { Button } from '@roc/ui';
import { useState } from 'react';
import { ConfirmRegenerateLinkModal } from './subcomponents/ConfirmRegenerateLinkModal';

export type IdAndFinancialInformationProps = {
  borrowerId: number;
  loan?: any;
  handleClose: () => void;
  refreshLoan?: () => void;
};

export const IdAndFinancialInformation = observer(
  (props: IdAndFinancialInformationProps) => {
    const { borrowerId, loan, handleClose, refreshLoan } = props;

    const { borrowerSetupToDoStore, identityCheckStore } = useStore();
    const { formInfo } = identityCheckStore;
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    useEffect(() => {
      identityCheckStore.reset();
      identityCheckStore.fetchFormInformation(loan.lenderId, borrowerId);
      borrowerSetupToDoStore.reset();
      borrowerSetupToDoStore.loadBorrowerPrescreenInfo(borrowerId, loan);
    }, []);

    return (
      <Grid
        container
        spacing={2}
        style={{
          width: '100%',
          minHeight: '180px',
        }}
      >
        {!!formInfo && (
          <>
            {formInfo.status === 'PENDING' ? (
              <IdAndFinancialInformationLink
                store={borrowerSetupToDoStore}
                lenderId={loan.lenderId}
              />
            ) : (
              <>
                <IdAndFinancialInformationSections
                  store={borrowerSetupToDoStore}
                  handleClose={handleClose}
                />
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="flex-end">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setShowConfirmModal(true)}
                      testId="regenerateLink"
                    >
                      Create Link
                    </Button>
                  </Box>
                </Grid>
              </>
            )}
          </>
        )}
        <ConfirmRegenerateLinkModal
          open={showConfirmModal}
          onClose={() => setShowConfirmModal(false)}
          onConfirm={() => {
            identityCheckStore.changeFormStatus(loan.loanId);
            setShowConfirmModal(false);
          }}
        />
        <Grid item xs={12} />
      </Grid>
    );
  }
);
